import type { PublicCombineMeasurementResponseRecord } from '@on3/api';
import { Check } from '@on3/ui-lib/components/Svg';
import { Text } from 'components/UI/Typography/Text';
import { useMemo } from 'react';

import styles from './CombineData.module.scss';
import { keysToConvertToFeet } from './TrackAndField/TrackAndFieldItem';

export const CombineDataItem = ({
  value,
  measurementType,
  measurementTypeKey,
  isVerified,
}: PublicCombineMeasurementResponseRecord) => {
  const isHeight = measurementTypeKey === 1;
  const is40 = measurementTypeKey === 6;

  const isInchesToFeet =
    measurementTypeKey && keysToConvertToFeet.includes(measurementTypeKey);

  // once units are added to the endpoint this will be changed to look at units.
  const isTimeFormat = measurementType?.units === 'secs';

  /** Rounds all values accordingly, and changes Height from inches to feet, */

  const formattedValue = useMemo(() => {
    if (value) {
      if (isInchesToFeet || isHeight) {
        const inches = value;
        const feet = Math.floor(inches / 12);
        const remainingInches = inches % 12;

        const formattedInches = `${remainingInches
          .toFixed(1)
          .replace(/\.?0+$/, '')}`;

        if (isHeight) {
          return `${feet}-${formattedInches}`;
        }

        return `${feet}'${formattedInches}"`;
      }

      if (isTimeFormat) {
        const minutes = Math.floor(value / 60);
        const remainingSeconds = Math.floor(value % 60);
        const milliseconds = Math.floor((value % 1) * 100);

        let timeString = '';

        if (minutes > 0) {
          timeString += minutes.toString() + ':';
        }

        timeString +=
          remainingSeconds.toString() + '.' + milliseconds.toString();

        return timeString;
      }

      return parseFloat(value.toFixed(2));
    }
  }, [isHeight, isInchesToFeet, isTimeFormat, value]);

  return (
    <li className={styles.combineListItem} key={measurementTypeKey}>
      <Text className={styles.name}>
        {measurementType?.type}
        {is40 && ' yard dash'}
      </Text>
      {!!value && <Text className={styles.value}>{formattedValue}</Text>}
      {isVerified && (
        <span className={styles.checkmarkContainer}>
          <Check className={styles.checkmark} />
        </span>
      )}
    </li>
  );
};
